export default __webpack_public_path__ + "static/media/cv.8852ef95.svg";